import * as yup from "yup";
import TagManager from "react-gtm-module";

export const sortItems = (items, keyToSort) => {
    return [...items].sort((a, b) => {
        if (a[keyToSort] < b[keyToSort]) {
            return -1;
        }
        if (a[keyToSort] > b[keyToSort]) {
            return 1;
        }
        return 0;
    });
};

export const validationSchema = yup.object({
    name: yup.string().required("Title is required"),
});

export const openPage = (url) => {
    if (url) window.location.replace(url, "blank_");
};

export const validateEmails = (value) => {
    // var validRegExp =
    //     /^[_a-zA-Z0-9-]+(\.[_a-zA-Z0-9-]+)*(\+[_a-zA-Z0-9-]+)?@[_a-zA-Z0-9-]+\.[A-Za-z]+$/;
    var validRegExp =
        /^[_a-zA-Z0-9-]+(\.[_a-zA-Z0-9-]+)*(\+[_a-zA-Z0-9-]+)?@[_a-zA-Z0-9-]+(\.[_a-zA-Z0-9-]+)*(\.[A-Za-z]+)$/;
    let emails = [];
    if (value) emails = value.split(",");
    if (emails.length > 0) {
        let result = true;
        emails.forEach((v) => {
            let trimmedEmail = v.trim();
            if (!validRegExp.test(trimmedEmail)) {
                result = false;
            }
        });
        return result;
    } else {
        if (!validRegExp.test(value)) {
            return false;
        }
    }
    return true;
};

export const processErrors = (errorObj) => {
    let detailsObj = errorObj?.error?.details;
    let errorsArray = [];

    for (const [key, value] of Object.entries(detailsObj)) {
        if (key) {
            let _val = "";
            if (value && Array.isArray(value) && value.length > 0) {
                value.forEach((message) => {
                    _val += message;
                });
            } else {
                _val = value;
            }
            errorsArray.push(_val);
        }
    }

    return errorsArray;
};

export const gtmpushToDataLayer = (eventName, eventParameters = {}) => {
    TagManager.dataLayer({
        dataLayer: {
            event: eventName,
            ...eventParameters,
        },
        dataLayerName: "PageDataLayer",
    });
};

export const changePriceFormat = (price) => {
    let result = price;
    if (price) result = price.replace(".", ",");

    return result;
};
